module.exports = __webpack_public_path__ + "static/media/index.d9ef15ce.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-closest/index.mjs
// module id = 698
// module chunks = 0